<template>
  <div class="pdf-container">
    <div v-if="dataReady" id="dataReady" />
    <div id="pdf-page-1" class="pdf-page">
      <div class="logo">
        <b-img
          v-if="lang != 'labels'"
          center
          :src="'/static/images/logo_color_' + lang + '.svg'"
          height="115"
        />
      </div>
      <div class="info-company">
        <b-row>
          <b-col cols="4" center>
            <b-img
              v-if="lang != 'labels'"
              center
              :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
              height="300"
            />
          </b-col>
          <b-col>
            <h3
              v-if="getBusiness.selfAssessment_general_business_companyName"
              id="companyName"
            >
              {{ getBusiness.selfAssessment_general_business_companyName }}
            </h3>
            <h4>{{ $t("label_reports_genderGap_title") }}</h4>
            <h4>{{ $t("label_reports_genderGap_subtitle") }}</h4>
            <h5>{{ $t("label_reports_date_caption") }} {{ today }}</h5>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-container v-if="!getIsloading">
      <b-row v-if="!emptyData">
        <b-col
          ><h3>{{ $t(currSection) }}</h3></b-col
        >
      </b-row>
      <b-container
        v-for="(question, questionIndex) in [
          ...getQuestionsCompleteBySection(currSection)[0],
        ]"
        :key="questionIndex"
      >
        <b-row v-if="!emptyData">
          <b-col
            ><p>{{ $t(question.name) }}</p></b-col
          >
        </b-row>
        <b-row v-if="emptyData">
          <b-col>
            <p class="noData">
              {{ $t("label_reports_opinionSurvey_notEnoughData") }}
            </p>
          </b-col>
        </b-row>
        <b-container
          v-for="filterC in question.filterCriteria"
          :key="filterC.name"
        >
          <b-row v-if="!emptyData">
            <b-col>
              <card-chart-opinion-survey
                :section="currSection"
                :question="question.name"
                :filter-criteria="filterC.name"
                type="participation"
                :alias="
                  currSection + question.name + filterC.name + 'participation'
                "
                height="300px"
              />
            </b-col>
          </b-row>
          <b-row v-if="!emptyData">
            <b-col>
              <card-chart-opinion-survey
                v-if="currSection !== 'label_opinionSurvey_harassment_title'"
                :section="currSection"
                :question="question.name"
                :filter-criteria="filterC.name"
                type="responses"
                :alias="
                  currSection + question.name + filterC.name + 'responses'
                "
                height="300px"
              />
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { createHelpers } from "vuex-map-fields";
import i18n from "../lang/lang";

const { mapFields } = createHelpers({
  getterType: "getOpinionSurveyField",
  mutationType: "updateOpinionSurveyField",
});

export default {
  name: "ReportsOpinionSurvey",
  data: function () {
    return {

      emptyData: false,
      today: "",
      currSection: "",
      dataReady: false,
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters([
      "getOpinionSurvey",
      "getOpinionSurveyFilteredSections",
      "getQuestionsBySection",
      "getFilterCriteriaByQuestion",
      "getOpinionSurveyCurrentQuestion",
      "getStateSections",
      "getOpinionSurveyQuestionIsEmpty",
      "pillarsIds",
      "getBusiness",
      "getToken",
      "getCurrentSnapshot",
      "getQuestionsCompleteBySection",
      "getBusiness",
      "getIsloading"
    ]),
    ...mapFields(["currentQuestionName", "currentFilterCriteria"]),
  },
  mounted() {
    this.checkIfIsEmpty();
  },
  methods: {
    ...mapMutations([
      "updateOpinionSurveyCurrentSection",
      "updateOpinionSurveyCurrentQuestionName",
    ]),
    checkIfIsEmpty() {
      this.emptyData = this.getOpinionSurveyQuestionIsEmpty;
    },
    showLabel(item) {
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
    showLabelCurrSection(item) {
      if (this.getOpinionSurveyFilteredSections.length === 0) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
    showLabelCurrQuestionName(item) {
      if (this.getQuestionsBySection(this.currentSection).length === 0) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
    showLabelcurrentFilterCriteria(item) {
      if (
        this.getFilterCriteriaByQuestion(this.currentQuestionName).length === 0
      ) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
  },
  created: function () {
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.business,
    };
    var snapshot = {
      snapshotId: this.$route.params.snapshot,
    };
    this.currSection = this.$route.params.currSection;
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    this.$store.commit("authSuccess", auth);
    this.$store.commit("setBusiness", business);
    this.$store.commit("setCurrentBusiness", business);
    this.$store.commit("setAccountRole", this.$route.params.accountroleid);
    this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
    this.$store.commit("setSnapshots", [snapshot]);
    this.$store.dispatch("OPINION_SURVEY_GET_REPORT").then(() => {
      if (this.getOpinionSurveyFilteredSections.length > 0) {
        this.updateOpinionSurveyCurrentSection({
          section: this.getOpinionSurveyFilteredSections[0],
          filteredQuestions: this.getQuestionsBySection(
            this.getOpinionSurveyFilteredSections[0]
          ),
        });
        this.updateOpinionSurveyCurrentQuestionName(this.currentQuestionName);
      }
      this.checkIfIsEmpty();
      this.dataReady = true;
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="sass">
.pbotom
  padding-bottom: 10px
.opt_title
  text-overflow: ellipsis
  white-space: normal
  overflow: hidden
.option__desc
  white-space: normal
  text-overflow: ellipsis
.multiselect__option--highlight
  background: rgb(2, 206, 167)
.multiselect__option--selected.multiselect__option--highlight
  background: #1e4380
  color: #fff
</style>
<style lang="sass" scoped>
// components/ReportsOpinionSurvey.vue
@import "../assets/css/variables.scss"

h3
  font-family: $font-subtitle
  font-size: 1.5rem
  margin-top: 20px
  text-transform: uppercase

.selectors
  margin-top: 1rem

.noData
  text-transform: uppercase
  font-weight: 500
  font-size: 1.4rem
  font-family: "Montserrat-Regular", sans-serif
  display: flex
  justify-content: center
  align-items: center
  height: 300px
</style>
